const en = {
  welcome: "Welcome",
  Login: "Login",
  Logout: "Logout",
  anonymous_user: "[anonymous] user",
  anonymous_message: "Type your anonymous message...",
  user_message: "Type your message",
  send: "Send",
  messages: "Messages",
  profile: "Profile",
  chat: "Chat",
  settings: "Settings",
  language: "Language",
  switch_to_english: "Switch to English",
  switch_to_greek: "Switch to Greek",
  error: "An error occurred",
  loading: "Loading...",
  restricted_access: "Restricted Access",
  not_found: "Page not found",
  visit_home_page: "Go to home page",
  go_back: "Go back",
  under_construction: "This website is currently under construction.",
  welcome_anonymous_world: "Open chat wall designed for freedom. Join the discussion instantly and anonymously, or sign up to build your identity.",
  enter:'Enter',
  register:'Register',
  register_success:'Registration was successful, you can now login...',
  login_success:'Login was successful, redirecting to Chat...',
  go_incognito:'Go incognito',
  back_to_chat:'Back to chat',
  this_website_under_construction:'This website is currently under construction by George Moysiadis.',
  logout: "Logout",
  login: "Login",
  log_in:'Log in',
  log_out:'Log out',
  sign_up:'Sign up',
  signup:'Sign up',
  anonymous:"anonymous user",
  wrote:"wrote",
  join_chat:'Join chat',
 no_messages_found:'No messages found.',
content_registered: 'Content is only available to registered users, not anonymous users!',
more_feautures: 'If you want to access more features of this website, please ',
create_an_account: 'create an account.',
add_email_fullname:'Add email and full name (optional)',
 password_recovery: 'for password recovery',
 email_optional: 'Email is optional, used for password recovery',
view_username_password: 'View username and password',
  username: 'Username',
  password: 'Password',
  tryingtosignin:'Trying to sign in...',
  tryingtosignup:'Trying to sign up...',
  forgot_password: 'Forgot password?',
  sorry_still_working: 'Sorry, I am still working on it :(',
  check_username_password: 'Please check username or password and try again.',
  fetching_user: "Fetching user...",
  incognito_mode_detected: "Incognito mode detected.",
  no_token_found: "No token found, setting user to null.",
  sending_request_to_users_me: "Sending request to /users/me...",
  user_fetched_successfully: "User fetched successfully:",
  error_fetching_user: "Error fetching user, logging out:",
  login_unsuccessful: "Login was not successful. Please try again.",
  login_timeout: "Login request timed out. Please try again.",
  login_failed: "Login failed",
  registration_successful: "Registration successful",
  registration_error: "Error during registration",
  server_error: "Server error. Please try again later.",
  logged_out: "You're now logged out. See you again soon!",
  changed_mind: "Changed your mind?",
  go_to_login_page: "Go to login page",
  view_messages: "View messages",
  blank_message:'Message is blank',
  send_message:'Send your message',
  'fill_username_password':'Fill username and password',
  'fill_username':'Fill username',
  'fill_password':'Fill password',
  'fill_email':'Fill email',
  invalid_email: 'Invalid email format',
  only_letters_numbers: 'Only letters and numbers are allowed in username',
  Only_letters_in_last_name: 'Only letters are allowed in last name',
  only_letters_in_first_name: 'Only letters are allowed in first name',
  click_here_login:'Click here to log in',
  click_here_singup:'Click here to sign up',
  view_email_fullname:'View email and full name',
  view_useranme_password:'View username and password',
  logged_out_successfully:'Logged out successfully!',
  no_email:' has not provided any email yet',
  no_fullname:' has not provided any full name yet',
  fullname:'Full name',
  switch_language_el: "Switch to Greek / Αλλάξτε στα Ελληνικά",
  switch_language_en: "Αλλάξτε στα Αγγλικά / Switch to English",
  visit_profile_info: 'Visit profile info',
  enter_chat_with_credentials: 'Enter chat with credentials',
  logout_title:'Logout from your account',
  sign_up_title: 'Sign up for an account',
  sign_in_title: 'Sign in to your account',
  go_incognito_title: 'Go incognito to chat anonymously',
  // Add more translations as needed

};

export default en;